import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import _isNumber from 'lodash/isNumber';
import DateUtils from '../../../../../utils/date/DateUtils';
import { FORMAT } from '../../ReservationForm.constants';
export function getReservationTimes(reservationDate) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (reservationDate) {
    var dayOfWeek = DateUtils.getIsoDayOfWeek(reservationDate, {
      format: FORMAT
    });
    var hours = location.hours,
      timezone = location.timezone;
    var dailyHours = hours.filter(function (_ref) {
      var day = _ref.day;
      return day === dayOfWeek;
    });
    if (dailyHours && dailyHours.length) {
      var allHours = dailyHours.map(function (hour) {
        var open = hour.open,
          close = hour.close;
        var referenceDate = DateUtils.parse(reservationDate, FORMAT);
        if (_isNumber(open) && _isNumber(close)) {
          return DateUtils.intervalsBetweenHoursInt(open, close, timezone, {
            format: 'h:mma',
            onlyFuture: true,
            referenceDate: referenceDate
          });
        }
        return [];
      });
      return allHours.flat(1);
    }
  }
  return [];
}
export function getReservationTimeOptions(location, reservationDate) {
  var locationId = location._id;
  return getReservationTimes(reservationDate, location).map(function (time) {
    return {
      key: "".concat(locationId, "-").concat(time),
      text: time,
      value: time
    };
  });
}
export function getReservationTimeSelectValue(value, reservationTimeOptions) {
  var reservationValue = reservationTimeOptions.find(function (option) {
    return option.value === value;
  });
  if (!reservationValue) return '';
  return reservationValue.value;
}